import { ChangeDetectionStrategy, Component, HostBinding, inject, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackbarModel } from '@libs/common/models';
import { IconComponent } from '@libs/components/icons';
import { IconName } from '@libs/shared/models';
import { ThemeColorName } from '@libs/themes';

@Component({
  selector: 'ui-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  imports: [MatButtonModule, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent implements SnackbarModel, OnInit {
  private readonly data: SnackbarModel | null = inject<SnackbarModel>(MAT_SNACK_BAR_DATA, { optional: true });
  protected readonly snackBarRef: MatSnackBarRef<unknown> | null = inject(MatSnackBarRef, { optional: true });

  @Input() public message: string = this.data?.message ?? '';
  @Input() public action?: string = this.data?.action;
  @Input() public useIcon?: boolean = this.data?.useIcon;
  @Input() public duration: number = this.data?.duration ?? 3000;
  @Input() @HostBinding('class') public theme?: ThemeColorName = this.data?.theme;

  public ngOnInit(): void {
    if (this.snackBarRef && !this.action) {
      this.snackBarRef._dismissAfter(this.duration);
    }
  }

  public getIcon(): IconName | undefined {
    if (!this.useIcon || !this.theme) {
      return;
    }

    const themeIconMap: Partial<Record<ThemeColorName, IconName>> = {
      success: 'circle-check',
      error: 'circle-xmark',
      warning: 'triangle-exclamation',
      info: 'circle-info',
    };

    return themeIconMap[this.theme];
  }
}
